class RamiuDetails extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.details.open) return;
      this.details.open = false;
      this.details.querySelector('summary')?.focus();
    });
  }
}

if (!customElements.get('ramiu-details')) {
  customElements.define('ramiu-details', RamiuDetails);
}

(() => {
  let updateFrame;

  const updateOverlayHeaders = () => {
    const isScrolled = window.scrollY > 24;

    document.querySelectorAll('.shell-header--overlay').forEach((header) => {
      header.classList.toggle('shell-header--scrolled', isScrolled);
    });

    updateFrame = undefined;
  };

  const requestHeaderUpdate = () => {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(updateOverlayHeaders);
  };

  updateOverlayHeaders();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  document.addEventListener('shopify:section:load', requestHeaderUpdate);
})();
